const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

const gtagEvent = (name, params = {}) => {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', name, params);
};

export function initGoogleAnalytics() {
  if (!MEASUREMENT_ID || typeof window === 'undefined') return;
  if (window.__nexorahGaInitialized) return;
  window.__nexorahGaInitialized = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', MEASUREMENT_ID, {
    send_page_view: true,
    allow_google_signals: false,
    allow_ad_personalization_signals: false,
  });
}

export function trackPageView(path) {
  if (!MEASUREMENT_ID || typeof window.gtag !== 'function') return;
  window.gtag('config', MEASUREMENT_ID, {
    page_path: path,
  });
}

/** Fired after email verification succeeds. No email or name sent. */
export function trackSignUp() {
  gtagEvent('sign_up', { method: 'email' });
}

/** Fired when redirecting to Stripe Checkout. No user PII. */
export function trackBeginCheckout({ planId, planName, value }) {
  const numericValue = Number(value);
  gtagEvent('begin_checkout', {
    currency: 'USD',
    value: Number.isFinite(numericValue) ? numericValue : 0,
    items: [
      {
        item_id: planId != null ? String(planId) : 'subscription',
        item_name: planName || 'Subscription',
      },
    ],
  });
}

/** Fired once when subscription is confirmed active. Uses Stripe session id only. */
export function trackPurchase({ sessionId, planId, planName, value }) {
  const dedupeKey = sessionId ? `ga_purchase_${sessionId}` : null;
  if (dedupeKey && sessionStorage.getItem(dedupeKey)) return;

  const numericValue = Number(value);
  gtagEvent('purchase', {
    transaction_id: sessionId || undefined,
    currency: 'USD',
    value: Number.isFinite(numericValue) ? numericValue : 0,
    items: [
      {
        item_id: planId != null ? String(planId) : 'subscription',
        item_name: planName || 'Subscription',
      },
    ],
  });

  if (dedupeKey) sessionStorage.setItem(dedupeKey, '1');
}
